import type { PaymentMethodType } from '../../../../../services/commonCheckout/types/PaymentMethod';
import PaymentMethodTypes from '../../../../../services/commonCheckout/utils/PaymentMethodTypes';
import type { FormattedPaymentMethod } from '../types';

export const isFormattedBankAccountPaymentMethod = (
  paymentMethod: FormattedPaymentMethod<PaymentMethodType>,
): paymentMethod is FormattedPaymentMethod<'BANK_ACCOUNT'> => {
  return paymentMethod.type === PaymentMethodTypes.BANK_ACCOUNT;
};
